import Playground from 'm3k-playground'
import styled, { createGlobalStyle } from 'styled-components'
import { DiNpm, DiGithubBadge } from 'react-icons/di'

import 'typeface-inter'

const code = `((getval set-attribute (getval body document)) "style" "margin: 0px; background-color: #ffffff;")

(define canvas ((getval create-element document) "canvas"))
(define ctx ((getval get-context canvas) "2d"))
(set! (getval width canvas) 400)
(set! (getval height canvas) 400)
((getval set-attribute canvas) "style" "position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)")

((getval append-child (getval body document)) canvas)

(define until (defun (cur limit fn)
  (if (< cur limit)
      (progn
        (fn cur limit)
        (until (+ cur 1) limit fn)))))

(define ball-arr (list))

(until 0 (+ (* 15 ((getval random Math))) 5) (defun ()
  (push ball-arr (dict
    :x (+ (* (- (getval width canvas) 100) ((getval random Math))) 80)
    :y (+ (* (- (getval height canvas) 100) ((getval random Math))) 80)
    :r 8
    :vx (+ (* (- 14) ((getval random Math))) 7)
    :vy (+ (* 7 ((getval random Math))) 2)
  ))))

(define update-ball (defun (ball)
  (progn
    (set! (getval x ball) (+ (getval x ball) (getval vx ball)))
    (set! (getval y ball) (+ (getval y ball) (getval vy ball)))
    (if (< (getval x ball) 0) (set! (getval vx ball) (* (getval vx ball) (- 1))))
    (if (> (getval x ball) (getval width canvas)) (set! (getval vx ball) (* (getval vx ball) (- 1))))
    (if (< (getval y ball) 0) (set! (getval vy ball) (* (getval vy ball) (- 1))))
    (if (> (getval y ball) (getval height canvas)) (set! (getval vy ball) (* (getval vy ball) (- 1))))
  )))

(define loop (defun ()
(progn
  (set! (getval fill-style ctx) "#f4f4f4")
  ((getval fill-rect ctx) 0 0 (getval width canvas) (getval height canvas))
  (until 0 (length ball-arr) (defun (cur)
    (progn
      (define b (nth cur ball-arr))
      (update-ball b)
      ((getval begin-path ctx))
      (set! (getval fill-style ctx) "black")
      ((getval arc ctx) (getval x b) (getval y b) (getval r b) 0 (* 2 (getval PI Math)))
      ((getval fill ctx))
    )))
  (request-animation-frame loop))))
(loop)`

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #ffffff;
    font-family: 'Inter', sans-serif;
    color: #0a0a0a;
  }

  * {
    box-sizing: border-box;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  padding-top: 5vh;
  padding-bottom: 5vh;
`

const PlaygroundWrapper = styled.div`
  max-width: 1300px;
  margin-top: 48px;
  width: 100%;
`

const Header = styled.h1`
  font-size: 48px;
  margin: 0px;
`

const Text = styled.p`
  font-size: 18px;
  font-weight: 500;
`

const LinksWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const Link = styled.a`
  width: 260px;
  display: flex;
  border: 1px solid #d2d2d2;
  color: #0a0a0a;
  text-decoration: none;
  border-radius: 5px;
  padding: 5px;
  align-items: center;

  &:not(:last-child) {
    margin-right: 10px;
  }

  &:hover {
    background-color: #f4f4f4;
  }
`

const IconWrapper = styled.div`
  width: 30%;
  font-size: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const LinkContentWrapper = styled.div`
  width: 70%;
`

const LinkTitle = styled.div`
  font-weight: bold;
`

const LinkDesc = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #707070;
`

function App() {
  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <Header>m3k</Header>
        <Text>m3k is an experimental lisp dialect that was written in <strong>TypeScript</strong> and compiles to <strong>JavaScript</strong></Text>
        <LinksWrapper>
          <Link href="https://github.com/obsfx/m3k" target="_blank">
            <IconWrapper>
              <DiGithubBadge />
            </IconWrapper>
            <LinkContentWrapper>
              <LinkTitle>Github</LinkTitle>
              <LinkDesc>Source & Language Overview</LinkDesc>
            </LinkContentWrapper>
          </Link>
          <Link href="https://www.npmjs.com/package/m3k" target="_blank">
            <IconWrapper>
              <DiNpm />
            </IconWrapper>
            <LinkContentWrapper>
              <LinkTitle>NPM</LinkTitle>
              <LinkDesc>Install via NPM</LinkDesc>
            </LinkContentWrapper>
          </Link>
        </LinksWrapper>
        <PlaygroundWrapper>
          <Playground width="1300px" height="720px" code={code} />
        </PlaygroundWrapper>
      </Wrapper>
    </>
  );
}

export default App;
